module.exports = __webpack_public_path__ + "img/motor_no25.123b27ce.jpg";